import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import { Button, TextInput } from '@opendate-app/setlist';
import CurrencyInput from '../../CurrencyInput/components/CurrencyInput';

// A per-event override field left null falls back to the team's fee rule (O-4411).
export const effectiveFee = (feeRule, field) => {
  const override = feeRule.calendar_event_fee_rule?.[field];
  return parseFloat(override ?? feeRule[field] ?? 0);
};

const FeeRuleRow = ({
  feeRule,
  handleChange,
  handleReset,
  handleBlur,
  isDisabled
}) => {
  const effectiveServiceFee = effectiveFee(feeRule, "organizer_service_fee");
  const effectivePercentage = effectiveFee(feeRule, "organizer_service_fee_percentage");

  const [serviceFee, setServiceFee] = useState(effectiveServiceFee.toFixed(2));
  const [percentage, setPercentage] = useState(String(effectivePercentage));

  useEffect(() => {
    setServiceFee(effectiveServiceFee.toFixed(2));
    setPercentage(String(effectivePercentage));
  }, [feeRule]);

  return (
    <div className="d-flex align-items-center" style={{"gap": "8px"}}>
      <div style={{"width": "120px"}}>
        <TextInput
          as={CurrencyInput}
          size="sm"
          aria-label="Your fee"
          leadingText="$"
          maskOptions={{ prefix: "", integerLimit: null }}
          disabled={isDisabled}
          onBlur={handleBlur}
          onChange={
            (e) => {
              const floatValue = parseFloat(e.target.value.replace(/[$,]/g, ""));
              setServiceFee(e.target.value);
              handleChange("organizer_service_fee", floatValue);
            }
          }
          value={serviceFee}
        />
      </div>
      <span style={{"color": "var(--sl-text-tertiary)"}}>+</span>
      <div style={{"width": "100px"}}>
        <TextInput
          size="sm"
          type="number"
          min="0"
          max="100"
          step="any"
          aria-label="Your fee percentage"
          trailingText="%"
          disabled={isDisabled}
          onBlur={handleBlur}
          onChange={
            (e) => {
              setPercentage(e.target.value);
              handleChange("organizer_service_fee_percentage", parseFloat(e.target.value));
            }
          }
          value={percentage}
        />
      </div>
      {feeRule.calendar_event_fee_rule ? (
        <Button
          variant="link-color"
          size="sm"
          onClick={() => handleReset(feeRule.calendar_event_fee_rule.id)}
        >
          Reset
        </Button>
      ) : null}
    </div>
  );
}

FeeRuleRow.propTypes = {
  feeRule: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  handleBlur: PropTypes.func,
  isDisabled: PropTypes.bool.isRequired
};

export default FeeRuleRow;
